<template>
  <span class="inspector-only-badge">
    <span class="inspector-only-badge__label">{{ label }}</span>
  </span>
</template>

<script setup>
/**
 * Static informational pill shown on Inspector-only checkpoint cards.
 * Explains why the card has no microlearning or quiz content; the only other
 * element in the MetaRow on those cards is the inspection status badge.
 * Read-only — no click target, tooltip or action (ER-11367 #5).
 */
const label = "No learning or inspection protocol available";
</script>

<style scoped>
.inspector-only-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  box-sizing: border-box;
  padding: 2px 8px;
  border-radius: 9999px; /* radius-full */
  border: 1px solid #eaecf0;
  background-color: #f9fafb;
  color: #475467;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  pointer-events: none; /* read-only — no click target, tooltip or action */
  cursor: default;
  user-select: none;
}
</style>
